module.exports = __webpack_public_path__ + "static/media/icon-linkedin.898c0407.png";